import {
  SET_CURRENT_TARGET,
  REMOVE_FROM_SELECTED_DAY_PART_NETWORKS,
  ADD_TO_SELECTED_DAY_PART_NETWORKS,
  SET_SELECTED_VIEWERSHIP_NETWORKS,
  CLOSE_DAY_PARTS_SECTION,
  SHOW_DELETE_TARGET_MODAL,
  SET_SHOW_APPEND_MODAL,
  SET_SHOW_PID_DOWNLOAD_MODAL,
  SET_TARGET_SEGMENTS,
  SET_TARGET_PID_LISTS,
  REMOVE_IS_DOWNLOADING_TARGET,
  IS_COMPLETED_DOWNLOAING_TARGET,
  IS_DOWNLOADING_TARGET,
  CLEAR_TARGET_DOWNLOAD,
  SET_CURRENT_TARGET_DEFINITION,
  SET_LOADING_VALUE,
  SHOW_REPOSSTING_MODAL,
  SET_TARGET_DROPPED_ATTRIBUTES,
  SET_TARGET_REPOST_DATES,
  SET_TARGET_NAME,
  SET_TARGET_ADVERTISER, SHOW_DROPPED_ATTRIBUTES_MODEL,
} from './actions'

const mutations = {
  [SET_CURRENT_TARGET] (state, target) {
    state.currentTarget = target
    state.currentTarget.promotedNetworks = target.target_definition.promotedNetworks
    state.hasChanged = false
  },
  [SET_TARGET_NAME] (state, name) {
    if (state.currentTarget) {
      state.currentTarget.display_name = name
      state.hasChanged = true
    }
  },
  [SET_TARGET_ADVERTISER] (state, advertiser) {
    if (state.currentTarget) {
      state.currentTarget.advertiser = advertiser
      state.hasChanged = true
    }
  },
  [SET_LOADING_VALUE] (state, value) {
    state.isLoading = value
  },
  [REMOVE_FROM_SELECTED_DAY_PART_NETWORKS] (state, index) {
    state.selectedDayPartNetworks.splice(index, 1)
  },
  [ADD_TO_SELECTED_DAY_PART_NETWORKS] (state, network) {
    state.selectedDayPartNetworks.push(network)
  },
  [SET_SELECTED_VIEWERSHIP_NETWORKS] (state, networks = []) {
    state.selectedViewershipNetworks = networks
  },
  [CLOSE_DAY_PARTS_SECTION] (state) {
    state.selectedDayPartNetworks = []
  },
  [SHOW_DELETE_TARGET_MODAL] (state) {
    if (state.showDeleteModal) {
      state.showDeleteModal = state.showDeleteModal + 1
    } else {
      state.showDeleteModal = 1
    }
  },
  [SET_SHOW_APPEND_MODAL] (state, target) {
    if (!target) {
      state.showAppendSegmentsModal = 0
    } else if (state.showAppendSegmentsModal) {
      state.currentTarget = target
      state.showAppendSegmentsModal = state.showAppendSegmentsModal + 1
    } else {
      state.currentTarget = target
      state.showAppendSegmentsModal = 1
    }
  },
  [SET_SHOW_PID_DOWNLOAD_MODAL] (state, target) {
    state.currentTarget = target
    if (state.showDownloadPidListModal) {
      state.showDownloadPidListModal = state.showDownloadPidListModal + 1
    } else {
      state.showDownloadPidListModal = 1
    }
  },
  [SET_TARGET_REPOST_DATES] (state, dateRange) {
    state.repostDates = dateRange.slice(0, -1)
  },
  [SET_TARGET_SEGMENTS] (state, segmentData) {
    state.segmentData = segmentData.data
  },
  [SET_TARGET_PID_LISTS] (state, pidLists) {
    state.pidLists = pidLists
  },
  [REMOVE_IS_DOWNLOADING_TARGET] (state, targetId) {
    state.isDownloadingTarget.delete(targetId)
    state.isDownloadingTarget = new Set(state.isDownloadingTarget.values())
  },
  [IS_COMPLETED_DOWNLOAING_TARGET] (state, targetId) {
    state.isCompletedDownloadingTarget.add(targetId)
    state.isCompletedDownloadingTarget = new Set(state.isCompletedDownloadingTarget.values())
  },
  [IS_DOWNLOADING_TARGET] (state, targetId) {
    state.isDownloadingTarget.add(targetId)
    state.isDownloadingTarget = new Set(state.isDownloadingTarget.values())
  },
  [CLEAR_TARGET_DOWNLOAD] (state) {
    state.isDownloadingTarget = new Set()
    state.isCompletedDownloadingTarget = new Set()
  },
  [SET_CURRENT_TARGET_DEFINITION] (state, td) {
    state.currentTarget.target_definition = td
  },
  [SHOW_REPOSSTING_MODAL] (state) {
    if (state.showRePostingModel) {
      state.showRePostingModel = state.showRePostingModel + 1
    } else {
      state.showRePostingModel = 1
    }
  },
  [SET_TARGET_DROPPED_ATTRIBUTES] (state, droppedAttributes) {
    state.droppedAttributes = droppedAttributes
  },
  [SHOW_DROPPED_ATTRIBUTES_MODEL] (state, shouldShow) {
    state.showDroppedAttributesModal = shouldShow
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/app/appLogic/targets/currentTarget/store/mutations.js